export default {
    breadcrumbs: {
        referrals: 'Referrals',
        received: 'Received',
        made: 'Made',
    },

    titles: {
        received: 'Referrals received',
        made: 'Referrals made',
    },

    controls: {
        status: 'View',
        filters: 'Filter',
        pagination: 'Show',
        number_per_page: '{n} per page',
        search: 'Search by provider or patient name',
    },

    statuses: {
        open: 'Open',
        closed: 'Completed',
        all: 'All',
    },

    headings: {
        from: 'From',
        to: 'To',
        patient: 'Patient',
        scheduled_for: 'Scheduled for',
        status: 'Status',
    },

    buttons: {
        view_details: 'View details',
        view_referral: 'View referral',
        respond: 'Respond',
        add_notes: 'Add report',
        show_more: 'Show more',
    },

    warnings: {
        reschedule: {
            hintTitle: ' ',
            text: 'Falls in within the next 24 hours',
        },
    },

    locations: {
        main: 'Main Location',
    },

    patient: {
        dob: 'DOB',
        tooltip: 'Patient information will be disclosed after HIPPA Privacy Rule is accepted',
    },

    filters: {
        title: 'Show referrals with status',
        pending_confirmation: 'Pending confirmation',
        patient_visit_pending: 'Patient visit pending',
        pending_insurance_auth: 'Pending ins. authorization',
        pending_consultation_report: 'Pending consultation report',
        to_be_rescheduled: 'To be rescheduled',
        out_of_availability: 'Out of actual availability',
        declined: 'Declined',
        cancelled: 'Cancelled',
        no_show: 'No show',
        completed: 'Completed',
    },
}
